export default {
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',

  // ControlledRepository component
  'component.controlledRepository.documentId': 'Document ID',
  'component.controlledRepository.documentName': 'Document Name',
  'component.controlledRepository.version': 'Version',
  'component.controlledRepository.process': 'Process',
  'component.controlledRepository.status': 'Status',
  'component.controlledRepository.baseline': 'Baseline',
  'component.controlledRepository.owner': 'Owner',
  'component.controlledRepository.searchPlaceholder': 'Search document name or ID',
  'component.controlledRepository.selectProcessPlaceholder': 'Select process',
  'component.controlledRepository.selectBaselinePlaceholder': 'Select baseline',
  'component.controlledRepository.search': 'Search',
  'component.controlledRepository.updateBaseline': 'Update Baseline',
  'component.controlledRepository.updateDocumentBaseline': 'Update Document Baseline',
  'component.controlledRepository.selectBaseline': 'Select Baseline',
  'component.controlledRepository.removeBaseline': '-- Remove Baseline --',
  'component.controlledRepository.removeBaselineDesc':
    'Select "Remove Baseline" to unlink document from baseline',
  'component.controlledRepository.selectBaselineRequired': 'Please select baseline',
  'component.controlledRepository.updateBaselineSuccess': 'Document baseline updated successfully',
  'component.controlledRepository.updateBaselineFailed': 'Failed to update document baseline',
  'component.controlledRepository.getDocumentsFailed': 'Failed to get document list',
  'component.controlledRepository.getProcessesFailed': 'Failed to get process list',
  'component.controlledRepository.getBaselinesFailed': 'Failed to get baseline list',
  'component.controlledRepository.notInBaseline': 'Not in baseline',

  // Document status
  'component.controlledRepository.status.draft': 'Draft',
  'component.controlledRepository.status.draftLocked': 'Draft Locked',
  'component.controlledRepository.status.review': 'Under Review',
  'component.controlledRepository.status.reviewPassed': 'Review Passed',
  'component.controlledRepository.status.auditPassed': 'Audit Passed',
  'component.controlledRepository.status.approved': 'Approved',
  'component.controlledRepository.status.controlled': 'Controlled',
  'component.controlledRepository.status.published': 'Published',
  'component.controlledRepository.status.obsolete': 'Obsolete',

  // CreateDocumentModal component
  'component.createDocumentModal.analyzingData': 'Analyzing integration system data...',
  'component.createDocumentModal.findingTemplate': 'Finding system template...',
  'component.createDocumentModal.understandingStructure': 'Understanding document structure...',
  'component.createDocumentModal.callingAI': 'Calling AI service...',
  'component.createDocumentModal.generatingContent': 'Generating document content...',
  'component.createDocumentModal.optimizingOutput': 'Optimizing output results...',
  'component.createDocumentModal.projectNotFound': 'Current project not found',
  'component.createDocumentModal.createFromTemplateSuccess':
    'Successfully created work product from template',
  'component.createDocumentModal.createFromExistingSuccess':
    'Successfully created from existing work product',
  'component.createDocumentModal.createFromLocalSuccess':
    'Successfully created work product from local file',
  'component.createDocumentModal.createFromIntegrateSuccess':
    'Successfully created work product from integration system',
  'component.createDocumentModal.createFailed': 'Creation failed',
  'component.createDocumentModal.permissionDenied':
    'Insufficient permissions, please contact administrator',
  'component.createDocumentModal.resourceNotFound':
    'Resource not found, please check configuration',
  'component.createDocumentModal.serverError': 'Internal server error, please try again later',
  'component.createDocumentModal.uploadFileFirst': 'Please upload file first',
  'component.createDocumentModal.fileNotExist': 'File does not exist or upload failed',
  'component.createDocumentModal.fileParseFailed': 'File content parsing failed',
  'component.createDocumentModal.creatingDocument': 'Creating document...',
  'component.createDocumentModal.createDocumentFailed': 'Failed to create document',
  'component.createDocumentModal.fileUploadFailed': 'File upload failed',
  'component.createDocumentModal.canceled': 'Document generation canceled',
  'component.createDocumentModal.csvData': 'CSV Data',
  'component.createDocumentModal.headers': 'Headers',
  'component.createDocumentModal.data': 'Data',
  'component.createDocumentModal.excelData': 'Excel Data',
  'component.createDocumentModal.columnNames': 'Column Names',
  'component.createDocumentModal.wordContent': 'Word Document Content',

  // TraceabilityComponent component
  'component.traceability.viewDocument': 'View Document',
  'component.traceability.notConfigured': 'Not Configured',
  'component.traceability.configureTraceColumn': 'Configure Trace Column',
  'component.traceability.selectTraceItems': 'Select trace items',
  'component.traceability.selectTraceItemsButton': 'Select Trace Items',
  'component.traceability.unknown': 'Unknown',
  'component.traceability.noTraceabilityData': 'No traceability dataset configured',
  'component.traceability.noTraceData': 'No trace data',
  'component.traceability.configureTraceColumnTitle': 'Configure Trace Column',
  'component.traceability.confirm': 'Confirm',
  'component.traceability.cancel': 'Cancel',
  'component.traceability.selectTraceColumn': 'Select Trace Column',
  'component.traceability.selectTraceColumnPlaceholder': 'Select trace column',
  'component.traceability.selectTraceItemsTitle': 'Select Trace Items',
  'component.traceability.selectAll': 'Select All',
  'component.traceability.selectTraceItemsDesc': 'Please select trace items',
  'component.traceability.process': 'Process',
  'component.traceability.workProduct': 'Work Product',
  'component.traceability.traceColumn': 'Trace Column',
  'component.traceability.traceItems': 'Trace Items',
  'component.traceability.searchTraceItems': 'Search chapter or content',
  'component.traceability.ungrouped': 'Ungrouped',
  'component.traceability.traceItemCount': '{{count}} items',
  'component.traceability.expiredCount': '{{count}} expired',
  'component.traceability.expiredTraceItems': 'Expired (no longer in source document)',
  'component.traceability.extraTraceItems': 'Selected but not in traceability matrix',
  'component.traceability.extraCount': '{{count}} not in matrix',
  'component.traceability.scopedHint': 'only items configured in the matrix',
  'component.traceability.showAllTraceItems': 'Show all {{count}} items',
  'component.traceability.noMatch': 'No matching items',
  'component.traceability.unmatchedTitle':
    '{{count}} configured trace item(s) not found in current content',
  'component.traceability.unmatchedDesc':
    'Usually the body was edited but not saved yet (IDs realign after saving), or this process now uses a different document. Check "Show all {{total}} items" to keep searching.',
  'component.traceability.noTraceColumnTitle': 'No trace items configured',
  'component.traceability.noTraceColumnDesc':
    'Please click "Select trace items" in the traceability matrix of process {{process}} first, then come back here. Showing all {{count}} items for now.',
  'component.traceability.done': 'Done',
  'component.traceability.summaryTable': 'Trace table',
  'component.traceability.summaryTableTip':
    'Collect all trace references in this chapter into a table appended to the end; regenerating replaces the previous one',
  'component.traceability.insertTargetAppend': 'Chapter end',
  'component.traceability.insertTargetCursor': 'At cursor',
  'component.traceability.insertOnlyHintAppend':
    'Checking appends the {{source}} reference to the end of this chapter; unchecking removes it from the content.',
  'component.traceability.insertOnlyHintCursor':
    'Checking inserts the {{source}} reference at the cursor; unchecking removes it from the content.',
  // Drawer scope: references come from upstream docs / other chapters of this doc / both
  'component.traceability.sourceUpstream': 'upstream item',
  'component.traceability.sourceSelf': 'other-chapter',
  'component.traceability.sourceAll': 'trace item',
  'component.traceability.noUpstreamDoc': 'No upstream document configured for this process yet',
  'component.traceability.noSelfBlocks':
    'This document has no paragraph or table row that can be traced yet',
  'component.traceability.resetDrawerTip':
    'Restore the default position and size; the next open will avoid the caret again',
  'component.traceability.drawerReset': 'Drawer position and size reset',
  'component.traceability.traceUpdatedNeedSave':
    'Trace written into content. Click Save on the page to persist.',
  'component.traceability.generateSummaryTable': 'Generate chapter traceability table',
  'component.traceability.summaryTableGenerated':
    'Generated a summary table with {{count}} trace items',
  'component.traceability.noRefToSummarize': 'No trace reference block inserted in this chapter.',
  'component.traceability.refInserted': 'Inserted {{count}} trace references into the content',
  'component.traceability.refRemoved': 'Removed {{count}} trace references from the content',
  'component.traceability.declaredOnly': 'Not in content',
  'component.traceability.declaredOnlyTip':
    'Legacy checkbox record: no matching reference block in the content. Uncheck and check again to truly insert it.',
  'component.traceability.orphanCannotInsert':
    'Expired items no longer exist in the source document and cannot be inserted.',
  'component.traceability.changedCount': '{{count}} changed',
  'component.traceability.changedTraceItems': 'Content changed (ID unchanged)',
  'component.traceability.updateTraceRefs': 'Update refs',
  'component.traceability.traceRefsUpdated': 'Aligned {{count}} references to the latest content',
  'component.traceability.insertOnlyHint':
    'Checking inserts a trace reference block into the content; unchecking removes it. Traceability always matches the content.',

  // Multiple references to the same item
  'component.traceability.refInsertedAgain': 'Added {{count}} more trace reference(s)',
  'component.traceability.alreadyReferenced':
    'These items are already referenced in this chapter; to add one more, click the + at the end of the row',
  'component.traceability.multiRefTip': 'Referenced {{count}} times in this chapter',
  'component.traceability.insertAgainTip':
    'Insert one more reference at the cursor (already referenced {{count}} times here)',
  'component.traceability.insertHereTip': 'Insert a reference at the cursor',
  'component.traceability.removeMultiRefsTitle': 'Remove all references?',
  'component.traceability.removeMultiRefsContent':
    '{{items}} item(s) are referenced in multiple places in this chapter ({{refs}} references in total). Unchecking removes all of them; to drop just one, delete that marker directly in the content.',
  'component.traceability.removeAll': 'Remove all',

  // Trace detail (strategy 1)
  'component.traceability.clickForDetail': 'Click to see where it is referenced',
  'component.traceability.detailTitle': 'Traceability detail',
  'component.traceability.detailUpstream': 'Upstream item',
  'component.traceability.detailDownstream': 'Downstream document',
  'component.traceability.detailHitCount': '{{count}} reference(s)',
  'component.traceability.detailNoChapter': 'No chapter label',
  'component.traceability.detailNoSnippet': 'Only declared; no locatable reference in the content',
  'component.traceability.snippetContext': 'context',
  'component.traceability.snippetContextPrefix': '(context) ',
  'component.traceability.blockTypeParagraph': 'Paragraph',
  'component.traceability.blockTypeTableRow': 'Table row',
  'component.traceability.blockTypeCell': 'Cell',
  'component.traceability.sourceRef': 'In-content reference',
  'component.traceability.sourceDeclared': 'Declared only',
  'component.traceability.sourceRefTip':
    'A reference block really inserted in the content; precise to paragraph / table row',
  'component.traceability.sourceDeclaredTip': 'Legacy checkbox record; only precise to chapter',

  // Traceability report export (strategy 5)
  'component.traceability.exportReport': 'Export report',
  'component.traceability.exportReportTip':
    'Export Excel: overview / one paired sheet per trace relation / uncovered / expired references',
  'component.traceability.previewReport': 'Preview report',
  'component.traceability.previewReportTip':
    'Check it on screen before exporting: same tables, same row order as the exported Excel',
  'component.traceability.previewTitle': 'Traceability report preview',
  'component.traceability.previewClose': 'Close',
  'component.traceability.previewRelationTable': 'Trace relation summary',
  'component.traceability.previewTotal': '{{count}} rows',
  'component.traceability.previewEmpty': 'No data in this table',
  'component.traceability.exportSuccess': 'Traceability report exported',
  'component.traceability.exportFail': 'Failed to export the traceability report',
  'component.traceability.exportEmpty': 'No traceability data to export',
  'component.traceability.reportFileName': 'TraceabilityReport',
  'component.traceability.reportSheetOverview': 'Overview',
  'component.traceability.reportSheetUncovered': 'Uncovered',
  'component.traceability.reportSheetExpired': 'Expired refs',
  'component.traceability.reportProject': 'Project',
  'component.traceability.reportGeneratedAt': 'Generated at',
  'component.traceability.reportUpstreamCount': 'Trace items',
  'component.traceability.reportDownstreamCount': 'Downstream processes',
  'component.traceability.reportHitCount': 'Total references',
  'component.traceability.reportCoveredCount': 'Covered items',
  'component.traceability.reportUncoveredCount': 'Uncovered items',
  'component.traceability.reportCoverage': 'Coverage',
  'component.traceability.reportExpiredCount': 'Expired refs',
  'component.traceability.reportColRelation': 'Trace relation',
  'component.traceability.reportColInvolvedProcess': 'Involved process',
  'component.traceability.noHitRow':
    'This process does not reference any trace item of the current process',
  'component.traceability.noWorkProductRow': 'No work product yet, traceability not applicable',
  'component.traceability.reportColIndex': '#',
  'component.traceability.reportColSelfProcess': 'Process',
  'component.traceability.reportColTraceId': 'Trace item ID',
  'component.traceability.reportColTraceDesc': 'Trace item description',
  'component.traceability.reportColDownProcess': 'Downstream process',
  'component.traceability.reportColDownDoc': 'Downstream document',
  'component.traceability.reportColChapter': 'Chapter',
  'component.traceability.reportColBlock': 'Block',
  'component.traceability.reportColSource': 'Source',
  'component.traceability.reportColDownId': 'Downstream ref ID',
  'component.traceability.reportColDownDesc': 'Downstream ref text',
  'component.traceability.reportColUncoveredBy': 'Not covered by',
  'component.traceability.reportColCoveredRatio': 'Covered / total',
  'component.traceability.reportColKind': 'Kind',
  'component.traceability.reportColWhere': 'Location',
  'component.traceability.reportColRemark': 'Remark',
  'component.traceability.expiredKindUpstream': 'Upstream declaration expired',
  'component.traceability.expiredKindDownstream': 'Downstream reference expired',
  'component.traceability.expiredKindBareId': 'Bare block id (legacy)',
  'component.traceability.expiredUpstreamDesc':
    'No matching item in the current source content; usually the body changed and the id drifted',
  'component.traceability.expiredDownstreamDesc':
    'The downstream content references this id, but the upstream item no longer exists',

  // AIGeneratingModal component
  'component.aiGenerating.title': 'AI Document Generation',
  'component.aiGenerating.description': 'Generating document based on your requirements',
  'component.aiGenerating.cancel': 'Cancel Generation',

  // AIGenerateModal component - Progress texts
  'component.aiGenerate.analyzingRequirements': 'Analyzing requirements...',
  'component.aiGenerate.findingTemplates': 'Finding system templates...',
  'component.aiGenerate.understandingStructure': 'Understanding document structure...',
  'component.aiGenerate.callingAI': 'Calling AI service...',
  'component.aiGenerate.generatingContent': 'Generating document content...',
  'component.aiGenerate.optimizingResults': 'Optimizing output results...',
  'component.aiGenerate.analyzingContent': 'Analyzing document content...',
  'component.aiGenerate.understandingRequirements': 'Understanding user requirements...',

  // AIGenerateModal component - Error messages
  'component.aiGenerate.resourceNotFound': 'Resource not found, please check configuration',
  'component.aiGenerate.permissionDenied': 'Insufficient permissions, please contact administrator',
  'component.aiGenerate.serverError': 'Server internal error, please try again later',
  'component.aiGenerate.requestFailed': 'Request failed, please try again later',
  'component.aiGenerate.cancelled': 'Document generation cancelled',
  'component.aiGenerate.failedTitle': 'AI Document Generation Failed',
  'component.aiGenerate.errorDetails': 'Error Details:',
  'component.aiGenerate.possibleSolutions': 'Possible Solutions:',
  'component.aiGenerate.checkTemplates': 'Check if templates labeled "Built-in Template" exist',
  'component.aiGenerate.checkAIConfig': 'Confirm that AI service configuration is correct',
  'component.aiGenerate.checkNetwork': 'Check if network connection is normal',
  'component.aiGenerate.retryOrContact': 'Try again later or contact administrator',
  'component.aiGenerate.generationFailed': 'Generation Failed',

  // ExportProgressModal component
  'component.exportProgress.title': 'Export Progress',

  // BaselineList component
  'component.baselineList.untitledDocument': 'Untitled Document',
  'component.baselineList.wordBlobError': 'Unable to get Word document Blob data',
  'component.baselineList.wordTimeoutError': 'Export Word document timeout',
};
